import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { INITIAL_STATE, SLICE_NAMESPACE } from './constants';
import { reducers } from './reducers';

const bannersSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState: INITIAL_STATE,
  reducers,
  extraReducers,
});

export const {
  updateBannersCreationTabPage,
  updateBannersVisualizationTabPage,
  resetBannersVisualizationTabFilters,
  updateBannersQuery,
  updateBannerTarget,
  toggleBannerListItem,
} = bannersSlice.actions;

export default bannersSlice.reducer;
